import { Component, OnInit, NgModule, OnDestroy } from '@angular/core';
import { NavService } from '../nav.service';
import { Router, NavigationEnd } from '@angular/router';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TransactionHistoryComponent } from '../transaction-history/transaction-history.component';
import { MatDialog } from '@angular/material';
import { GlobalEventsManager } from '../global-events-manager';
import { InfoDialogComponent } from '../nav/info-dialog/info-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { AlertsService } from '../alerts.service';
import { TrainingVideosService } from '../training-videos.service';
import { VideoTraining } from '../VideoTraining';
import { MediaChange, ObservableMedia } from '@angular/flex-layout';
import { ThemeService } from '../theme.service';
import { LoginService } from '../login.service';
import AppLink from 'src/AppLink';
import { AgencyEmailDialogComponent } from './agency-email-dialog/agency-email-dialog.component';

@NgModule({
  imports: [
    AngularFontAwesomeModule
  ]
})

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {

  watcher: any;
  sideNavOpened = true;
  sidenavMode = 'side';
  sideNavCloseDisabled = true;
  isMobileView = false;
  clearance: number;

  // Get route name
  pageSelected = window.location.href.split('/')[window.location.href.split('/').length - 1] || 'my-day';

  refreshTimer: any;
  // isNavbarCollapsed = true;
  activeBranches: Object[] = [];
  branch = '';
  showNav = false;
  numAlerts = 0;

  videos: VideoTraining[] = [];
  // tslint:disable-next-line: no-inferrable-types
  videosLoading: boolean = true;
  isInfoModalOpened: boolean;
  showFlash: boolean;

  appLinks: AppLink[] = [];

  constructor(
    private alertService: AlertsService,
    // private route: ActivatedRoute,
    public tvAPI: TrainingVideosService,
    private navService: NavService,
    private router: Router,
    public dialog: MatDialog,
    public loginService: LoginService,
    private globalEventsManager: GlobalEventsManager,
    public themeService: ThemeService,
    media: ObservableMedia
  ) {
    this.themeService.startTheme();

    router.events.subscribe(event => {
      // This is triggered whenever a route is changed
      if (event instanceof NavigationEnd) {
        const splittedURL = event.url.split('/');
        this.pageSelected = splittedURL[splittedURL.length - 1] || 'my-day';

        // Since this component is called when the page first loads, clearance can carry old local storage information (like null)
        // The solution here is to update the clearance each time the user navigates between routes
        this.clearance = Number(localStorage.getItem('clearance'));
      }
    });

    this.globalEventsManager.showNavBarEmitter.subscribe(mode => {
      if (mode) {
        this.showNav = true;
        localStorage.setItem('showNav', 'true');
        this.getActiveBranches();
        this.getTrainingVideos();
        this.getApps();
      }
    });

    this.globalEventsManager.logoutEmitter.subscribe(mode => {
      if (mode) {
        this.goLogout();
      }
    });

    this.watcher = media.subscribe((change: MediaChange) => {
      if (change.mqAlias === 'xs') {
        this.sidenavMode = 'over';
        this.sideNavCloseDisabled = false;
        this.sideNavOpened = false;
        this.isMobileView = true;
      } else {
        this.sideNavOpened = true;
        this.sideNavCloseDisabled = true;
        this.sidenavMode = 'side';
        this.isMobileView = false;
      }
    });
  }

  ngOnInit() {
    if (localStorage.getItem('token')) {
      this.getTrainingVideos();
      this.getApps();
    }

    this.updateAlertCount();
    if (localStorage.getItem('showNav') === 'true') {
      this.showNav = true;
      this.getActiveBranches();
    }

    this.refreshTimer = setInterval(() => {
      this.updateAlertCount();
    }, 1000 * 60 * 10);
  }

  ngOnDestroy(): void {
    if (this.watcher.unsubscribe) {
      this.watcher.unsubscribe();
    }
    clearInterval(this.refreshTimer);
  }

  getActiveBranches(  ): void {
    this.updateAlertCount();
    this.navService.getActiveBranches().subscribe((data) => {
      this.populateBranches(data);
    });
  }

  populateBranches( data: any ) {
    this.updateAlertCount();
    this.activeBranches = [];
    this.activeBranches.push({code: '', name: 'All'});
    for (const item of data) {
      this.activeBranches.push({code: item.code, name: item.name});
    }
  }

  openAlerts() {
    this.updateAlertCount();
    // this.isNavbarCollapsed = true;
    this.dialog.open(AlertDialogComponent, {width: '900px', autoFocus: true})
    .afterClosed()
    .subscribe(result => {});
  }

  openAgencyEmailDialog() {
    this.dialog.open(AgencyEmailDialogComponent, {width: '800px', autoFocus: true})
    .afterClosed()
    .subscribe(() => {});
  }

  goHistory() {
    this.updateAlertCount();
    // this.isNavbarCollapsed = true;
    this.dialog.open(TransactionHistoryComponent, {width: '80%', autoFocus: true})
    .afterClosed()
    .subscribe(result => {

    });
  }

  updateAlertCount() {
    this.alertService.getAlertCount().subscribe((data) => {
      if (data && data[0]) {
        this.numAlerts = data[0][0];
      }
    });
  }

  goLogout() {
    localStorage.clear();
    this.showNav = false;
    this.router.navigate(['/']);
  }

  getTrainingVideos(): void {
    this.videosLoading = true;
    this.tvAPI.getTrainingVideos().subscribe((videos: VideoTraining[]) => {
      this.videos = videos.map(video => ({
        ...video,
        loading: false // show indicator that video isn't loaded yet
      }));
      this.showFlash = videos.some(({ isWatched }) => !isWatched); // check if some videos are not watched
    }, err => {
      console.error(err);
    }, () => {
      this.videosLoading = false;
    });
  }

  openInfo() {
    if (!this.isInfoModalOpened) {
      this.isInfoModalOpened = true;
      this.updateAlertCount();
      // this.isNavbarCollapsed = true;
      this.showFlash = false;

      this.dialog.open(
        InfoDialogComponent,
        {
          data: this.videos,
          width: '95%',
          autoFocus: true,
          panelClass: 'info-dialog-container',
          position: {
            bottom: '15px'
          }
        }
      )
      .afterClosed()
      .subscribe(() => {
        this.isInfoModalOpened = false;
        this.getTrainingVideos();
      });
    }
  }

  navClicked(route: string): void {
    // this.isNavbarCollapsed = true;
    localStorage.removeItem('selectedBranchCode');
    localStorage.removeItem('selectedBranchName');
    this.router.navigate([route]);
    // this.pageSelected = route;
    if (this.isMobileView) {
      this.sideNavOpened = false;
    }
  }

  toggleSidebar(): void {
    this.sideNavOpened = !this.sideNavOpened;
  }

  getApps(): void {
    this.navService.getAppLinks().subscribe(data => {
      this.appLinks = data;
    });
  }

  onImageError(e: ErrorEvent): void {
		(e.currentTarget as HTMLImageElement).src = "https://inspeqtech.com/images/logo_40px.png";
  }

}
